<template>
  <div class="card-wrapper">
    <div id="card-error" class="align-center color-lip">{{ cardError }}</div>
    <h6 class="title mb-10">{{ $t("upgrade.card_number") }}</h6>
    <div id="card-number" class="card-input mb-20"></div>

    <h6 class="title mb-10">{{ $t("upgrade.expiry_date") }}</h6>

    <div class="flex items-center">
      <div id="card-expiry" class="card-input"></div>
      <div class="flex-1"></div>
      <div id="card-cvc" class="card-input"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  components: {},
  props: {},
  data: function () {
    return {
      token: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      cardError: "",
    };
  },
  computed: {
    stripeElements() {
      return this.$stripe.elements();
    },
  },
  beforeDestroy() {
    if (this.cardNumber) {
      this.cardNumber.destroy();
      this.cardExpiry.destroy();
      this.cardCvc.destroy();
    }
  },
  async mounted() {
    let theme = document.body.getAttribute("data-theme");

    let styleCard = {
      base: {
        fontSize: "20px",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "#ff0368",
        iconColor: "#ff0368",
      },
      complete: {
        color: "#2ab900",
      },
    };

    if (theme == "dark") {
      styleCard.base.color = "#fff";
    }

    const styleCVC = {
      ...styleCard,
      base: {
        ...styleCard.base,
        textAlign: "center",
      },
    };

    this.cardNumber = this.stripeElements.create("cardNumber", { showIcon: true, style: styleCard });
    this.cardNumber.mount("#card-number");

    this.cardExpiry = this.stripeElements.create("cardExpiry", { style: styleCVC });
    this.cardExpiry.mount("#card-expiry");

    this.cardCvc = this.stripeElements.create("cardCvc", { style: styleCVC });
    this.cardCvc.mount("#card-cvc");

    this.cardNumber.on("ready", (v) => {
      this.cardNumber.focus();
    });
  },
  methods: {
    focus() {
      if (this.cardNumber) {
        setTimeout(() => {
          this.cardNumber.focus();
        }, 500);
      }
    },
    async createToken() {
      const { token, error } = await this.$stripe.createToken(this.cardNumber);
      if (error) {
        this.cardError = error.message;
        return false;
      }
      this.cardError = "";
      return token;
    },
  },
};
</script>
